import { toast } from "react-toastify";

const errorHandler = () => {
  let setFieldErrorCustom = (errors: any) => {
    try {
      if (!errors || errors?.toLowerCase?.()?.includes?.("<!doctype")) {
        toast.error("Something Went Wrong!!");
        return;
      } else if (typeof errors === "string") {
        toast.error(errors);
        return;
      }

      if (Array.isArray(errors)) {
        errors.forEach((error) => {
          setFieldErrorCustom(error);
        });
      } else {
        Object.keys(errors).forEach((errorField) => {
          setFieldErrorCustom(errors[errorField]);
        });
      }
    } catch (error) {
      console.error("Error: ", error);
      toast.error("Something Went Wrong!!");
    }
  };

  return {
    setFieldErrorCustom,
  };
};

export default errorHandler;
